import type { ReactNode } from 'react';
import { resolveImageUrl } from '@/shared/utils/publishingAsset';
import { BREAKPOINT } from '@publishing/helpers';
import { resolveResponsiveImage } from '@publishing/helpers/responsive';
import type { CarouselTabsImage } from './types';
import s from './CarouselTabsSection.module.scss';

export function SlideImage({
  image,
  alt,
  className,
  caption,
}: {
  image: CarouselTabsImage;
  alt?: string;
  className: string;
  caption?: ReactNode;
}) {
  const [img, imgMo] = resolveResponsiveImage(image);

  return (
    <div className={s.carousel_slide_wrap}>
      <picture className={s.carousel_picture}>
        {imgMo && (
          <source
            srcSet={resolveImageUrl(imgMo)}
            media={`(max-width: ${BREAKPOINT}px)`}
          />
        )}
        <img src={resolveImageUrl(img)} alt={alt ?? ''} className={className} />
      </picture>
      {caption && <p className={s.carousel_caption}>{caption}</p>}
    </div>
  );
}
